<template>
  <div class="vx-col w-full text-center mt-5">
    <vs-spinner></vs-spinner>
  </div>
</template>

<script>
// Atalho de menu ("Meu cadastro") para quem só enxerga a própria entidade:
// sem isto, o profissional só chegava no próprio cadastro (e na aba "Repasse
// (Stripe)" dentro dele) navegando por "Profissional > Gestão" — uma tela de
// grid pensada para quem administra vários profissionais, não para achar a
// própria ficha.
export default {
  async mounted() {
    if (!this.$store.getters['dataAccess/loaded']) {
      await this.$store.dispatch('dataAccess/setupFromLogin')
    }

    const activeId = this.$store.getters['dataAccess/activeInstitutionId']
    const entities = this.$store.getters['dataAccess/entities'] || []
    const targetId = activeId || (entities.length === 1 ? entities[0].id : null)

    if (targetId) {
      this.$router.replace(`/professionals/${targetId}/edit`)
    } else {
      this.$router.replace('/professionals')
    }
  }
}
</script>
